export default import.meta.ROLLDOWN_FILE_URL("assets/ringCentralLogo-BAYsvsol.png")